import type { ReactNode } from 'react';

import { useViewport } from '../../hooks';
import { Flex } from '../Flex';
import { Nowrap } from '../Nowrap';
import { Text } from '../Text';

export interface FooterLinkGroupProps {
  title: string;
  badge?: string | ReactNode;
  children: ReactNode;
  className?: string;
}

/** A group component for organizing links with a title */
export function FooterLinkGroup({
  title,
  badge,
  children,
  className,
}: FooterLinkGroupProps) {
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <Flex direction="column" gap={isMobile ? 'sm' : 'md'} className={className}>
      {title && (
        <Text as="h4" variant="heading-16" bold vSpacing="none">
          {title}
          {typeof badge === 'string' ? (
            <Text
              as="span"
              variant="article-12"
              color="Kale1"
              fontStyle="italic"
              vSpacing="none"
              leftSpacing="sm"
            >
              <Nowrap>{badge}</Nowrap>
            </Text>
          ) : (
            badge
          )}
        </Text>
      )}
      {children}
    </Flex>
  );
}
